import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';


import helpImg from '../../../assets/images/help-icon.png';
import archiveImg from '../../../assets/images/archive-black-icon.png';
import NavigationItem from './NavigationItem/NavigationItem';
import Button from '../../UI/Button/Button';
import Dropdown from '../../UI/Dropdown/Dropdown';
import Aux from '../../../hoc/Auxiliary/Auxiliary';
import classes from './NavigationItems.css';
import logError from '../../../store/LogError';
import axios from '../../../axios-trips';
import * as actionTypes from '../../../store/actions';

export class NavigationItems extends Component {

  render() {
    let logoutHandler = () => {
      axios({
        method: 'post',
        url: '/api/v1/tokens/revoke/' + this.props.access_token,
        headers: { 'Authorization': 'Bearer ' + this.props.access_token },
      })
        .then(response => {
          console.log(response);
          this.props.addNotification("Ви успішно вийшли з акаунта.", "Success");
          localStorage.removeItem("access_token");
          localStorage.removeItem("refresh_token");
          this.props.onSetManagerName(null);
          this.props.onLogout();
        })
        .catch(error => {
          console.log(error);
          if (error.response) {
            logError(
              this.props.access_token,
              this.props.codeToMessage[error.response.status],
              '/api/v1/tokens/revoke/' + this.props.access_token
            );
            this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
          } else if (!error.response) {
            this.props.addNotification("Сервер не відповідає.", "Danger");
          }
        });
    }

    let logoutButton = <NavigationItem itemType="Link" link='/account'>Профіль</NavigationItem>;
    let newTripButton = null;
    let account = null;
    let tracking = null;
    let filters = null;
    if (this.props.access_token !== null && this.props.access_token !== undefined) {
      logoutButton = (
        <NavigationItem itemType="Action" clicked={logoutHandler} link='/account'>Вийти</NavigationItem>
      );
      if (this.props.role === 'ROLE_ADMIN' || this.props.role === 'ROLE_DISPATCHER') {
        newTripButton = (
          <Dropdown className={classes.NavigationDropdown} dropdown="СТВОРИТИ">
            <Button
              btnType='Danger'
              clicked={() => this.props.onShowNewTrip(!this.props.showNewTrip)}
              extraClass={classes.ButtonDropdown}>НОВИЙ РЕЙС</Button>
            <Button
              btnType='Danger'
              clicked={() => this.props.onShowNewRequest(!this.props.showNewRequest)}
              extraClass={classes.ButtonDropdown}>НОВА ЗАЯВКА</Button>
            <Button
              btnType='Danger'
              clicked={() => this.props.onShowNewCarrier({})}
              extraClass={classes.ButtonDropdown}>НОВИЙ ПЕРЕВІЗНИК</Button>
            <Button
              btnType='Danger'
              clicked={() => this.props.onShowNewRequestLink(!this.props.showNewRequestLink)}
              extraClass={classes.ButtonDropdown}>ПОСИЛАННЯ НА ЗАЯВКУ</Button>
            <Button
              btnType='Danger'
              clicked={() => this.props.onShowDriverForm(true, null)}
              extraClass={classes.ButtonDropdown}>НОВИЙ ВОДІЙ</Button>
          </Dropdown>
        );
        tracking = (
          <NavigationItem itemType="Link" link='/trip-tracking'>Відстеження Авто</NavigationItem>
        );
      } else if (this.props.role === 'ROLE_MANAGER' || this.props.role === 'ROLE_RULER') {
        newTripButton = (
          <Dropdown className={classes.NavigationDropdown} dropdown="СТВОРИТИ">
            <Button
              btnType='Danger'
              clicked={() => this.props.onShowNewRequest(!this.props.showNewRequest)}
              extraClass={classes.ButtonDropdown}>НОВА ЗАЯВКА</Button>
          </Dropdown>
        );
      }

      filters = (
        <Aux>
          <Dropdown className={classes.NavigationDropdown} dropdown="ДОПОМОГА">
            <a href="https://sites.google.com/view/ufc-help/kanban-ufc-dp-ua" target="_blank" rel="noopener noreferrer" className={classes.HelpLinkDropdown}>
              <img src={helpImg} className={classes.HelpIconSmall} alt="Допомога" />
              <span>ДОПОМОГА</span>
            </a>
            <Button
              btnType='Danger'
              clicked={() => this.props.history.push('/about')}
              extraClass={classes.ButtonDropdown}>ПРО ПРОГРАМУ</Button>
          </Dropdown>
          <NavigationItem itemType="Link" link='/archived'>
            <img src={archiveImg} className={classes.Icon} alt="Архів" />
          </NavigationItem>
          <Dropdown
            dropdown={this.props.filterDispatcher ? "ПОШУК" : "ФІЛЬТРИ"}
            className={[this.props.filterDispatcher ? [classes.Filter, classes.SelectedFilter].join(' ') : classes.Filter, classes.NavigationDropdown].join(' ')}>
            <Button
              btnType='Danger'
              clicked={(ev) => this.props.onFilterDispatcher(!this.props.filterDispatcher)}
              extraClass={this.props.filterDispatcher ? classes.ButtonDropdownActive : classes.ButtonDropdown}>ПОШУК</Button>
          </Dropdown>
        </Aux>
      );
    } else if (this.props.role === 'ROLE_MANAGER' || this.props.role === 'ROLE_RULER') {
      filters = (
        <Aux>
          <Dropdown className={classes.NavigationDropdown} dropdown="ДОПОМОГА">
            <a href="https://sites.google.com/view/ufc-help/kanban-ufc-dp-ua" target="_blank" rel="noopener noreferrer" className={classes.HelpLinkDropdown}>
              <img src={helpImg} className={classes.HelpIconSmall} alt="Допомога" />
              <span>ДОПОМОГА</span>
            </a>
            <Button
              btnType='Danger'
              clicked={() => this.props.history.push('/about')}
              extraClass={classes.ButtonDropdown}>ПРО ПРОГРАМУ</Button>
          </Dropdown>
          <Dropdown
            dropdown={this.props.filterManager ? "МОЇ ЗАЯВКИ" : "ФІЛЬТРИ"}
            className={[this.props.filterManager ? [classes.Filter, classes.SelectedFilter].join(' ') : classes.Filter, , classes.NavigationDropdown].join(' ')}>
            <Button
              btnType='Danger'
              clicked={(ev) => this.props.onFilterManager(!this.props.filterManager)}
              extraClass={this.props.filterManager ? classes.ButtonDropdownActive : classes.ButtonDropdown}>МОЇ ЗАЯВКИ</Button>
          </Dropdown>
        </Aux>
      );
    } else if (this.props.role === 'ROLE_RULER') {
      filters = (
        <Aux>
          <a href="https://sites.google.com/view/ufc-help/kanban-ufc-dp-ua" target="_blank" className={classes.HelpLink}>
            <img src={helpImg} className={classes.HelpIcon} alt="Допомога" />
            <p className={classes.HelpText}><em>ДОПОМОГА</em></p>
          </a>
        </Aux>
      );
    } else if (this.props.role === 'ROLE_ADMIN') {
      filters = (
        <Aux>
          <Dropdown className={classes.NavigationDropdown} dropdown="ДОПОМОГА">
            <a href="https://sites.google.com/view/ufc-help/kanban-ufc-dp-ua" target="_blank" rel="noopener noreferrer" className={classes.HelpLinkDropdown}>
              <img src={helpImg} className={classes.HelpIconSmall} alt="Допомога" />
              <span>ДОПОМОГА</span>
            </a>
            <Button
              btnType='Danger'
              clicked={() => this.props.history.push('/about')}
              extraClass={classes.ButtonDropdown}>ПРО ПРОГРАМУ</Button>
          </Dropdown>
          <NavigationItem itemType="Link" link='/archived'>
            <img src={archiveImg} className={classes.Icon} alt="Архів" />
          </NavigationItem>
          <Dropdown
            dropdown={this.props.filterDispatcher ? "ПОШУК" : this.props.filterManager ? "МОЇ ЗАЯВКИ" : "ФІЛЬТРИ"}
            className={
              [this.props.filterDispatcher || this.props.filterManager ?
                [classes.Filter, classes.SelectedFilter].join(' ') :
                classes.Filter, classes.NavigationDropdown].join(' ')}>
            <Button
              btnType='Danger'
              clicked={(ev) => this.props.onFilterDispatcher(!this.props.filterDispatcher)}
              extraClass={this.props.filterDispatcher ? classes.ButtonDropdownActive : classes.ButtonDropdown}>ПОШУК</Button>
            <Button
              btnType='Danger'
              clicked={(ev) => this.props.onFilterManager(!this.props.filterManager)}
              extraClass={this.props.filterManager ? classes.ButtonDropdownActive : classes.ButtonDropdown}>МОЇ ЗАЯВКИ</Button>
          </Dropdown>
        </Aux>
      );
    }

    return (
      <ul className={classes.NavigationItems}>
        {filters}
        {newTripButton}
        <NavigationItem itemType="Link" link='/'>Рейси</NavigationItem>
        {tracking}
        {account}
        {logoutButton}
      </ul>
    );
  }
};

const mapStateToProps = state => {
  return {
    access_token: state.access_token,
    showNewTrip: state.showNewTrip,
    showNewRequest: state.showNewRequest,
    showNewCarrier: state.showNewCarrier,
    role: state.role,
    filterDispatcher: state.filterDispatcher,
    filterManager: state.filterManager,
    showNewRequestLink: state.showNewRequestLink,
    codeToMessage: state.codeToMessage
  };
}

const mapDispatchToProps = dispatch => {
  return {
    addNotification: (notification, notificationType) => dispatch({
      type: actionTypes.ADD_NOTIFICATION,
      notification: notification,
      notificationType: notificationType
    }),
    onSetManagerName: (managerName) => dispatch({
      type: actionTypes.MANAGER_NAME,
      managerName: managerName
    }),
    onLogout: () => dispatch({ type: actionTypes.LOGOUT }),
    onShowNewTrip: (showNewTrip) => dispatch({ type: actionTypes.SHOW_NEW_TRIP, showNewTrip: showNewTrip }),
    onShowNewRequest: (showNewRequest) => dispatch({ type: actionTypes.SHOW_NEW_REQUEST, showNewRequest: showNewRequest }),
    onShowNewCarrier: (showNewCarrier) => dispatch({ type: actionTypes.SHOW_NEW_CARRIER, showNewCarrier: showNewCarrier }),
    onShowNewRequestLink: (showNewRequestLink) => dispatch({ type: actionTypes.SHOW_NEW_REQUEST_LINK, showNewRequestLink: showNewRequestLink }),
    onFilterDispatcher: (filterDispatcher) => dispatch({
      type: actionTypes.FILTER_DISPATCHER,
      filterDispatcher: filterDispatcher
    }),
    onFilterManager: (filterManager) => dispatch({
      type: actionTypes.FILTER_MANAGER,
      filterManager: filterManager
    }),
    onShowDriverForm: (showDriverForm, driver) => dispatch({
      type: actionTypes.SHOW_DRIVER_FORM,
      showDriverForm: showDriverForm,
      driver: driver
    }),
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NavigationItems));



// WEBPACK FOOTER //
// ./src/components/Navigation/NavigationItems/NavigationItems.js